// import React, { useEffect, useRef, useState, useContext } from "react";
// import {
//   BedOutlined,
//   CreditCardOutlined,
//   MonetizationOnOutlined,
//   KeyOutlined,
// } from "@mui/icons-material";
// import gsap from "gsap";
// import { LanguageContext } from "./LanguageContext"; // ✅ استيراد الكونتكست

// const LuxuryInfoSection = () => {
//   const { language } = useContext(LanguageContext); // ✅ الحصول على اللغة
//   const cardsRef = useRef([]);
//   const sectionRef = useRef(null);
//   const [isMobile, setIsMobile] = useState(false);

//   // ✅ النصوص حسب اللغة
//   const translations = {
//     en: {
//       title: "Welcome to Masaar 3",
//       paragraph:
//         "Following the overwhelming response to Masaar, Masaar 2, Arada’s second community in Sharjah’s densely wooded surroundings, has finally been launched with a variety of residential options ranging from two-bedroom townhouses to five-bedroom luxury villas.",
//       items: [
//         {
//           icon: <BedOutlined fontSize="large" />,
//           title: "Consists of",
//           subtitle: "2-, 3-, 4- and 5-room",
//         },
//         {
//           icon: <CreditCardOutlined fontSize="large" />,
//           title: "Down Payment",
//           subtitle: "5%",
//         },
//         {
//           icon: <MonetizationOnOutlined fontSize="large" />,
//           title: "Payment Plan",
//           subtitle: "Installments until handover",
//         },
//         {
//           icon: <KeyOutlined fontSize="large" />,
//           title: "Handover Time",
//           subtitle: "Handover in 2027",
//         },
//       ],
//     },
//     ar: {
//       title: "مرحبًا بك في مسار 3",
//       paragraph:
//         "بعد النجاح الكبير لمشروع مسار، تم إطلاق مسار 2، ثاني مجتمعات أرادَ السكنية وسط المساحات الخضراء الكثيفة في الشارقة، ويضم مجموعة متنوعة من الخيارات السكنية من منازل التاون هاوس بغرفتي نوم إلى فلل فاخرة مكونة من خمس غرف.",
//       items: [
//         {
//           icon: <BedOutlined fontSize="large" />,
//           title: "يتكون من",
//           subtitle: "غرف 2 و3 و4 و5",
//         },
//         {
//           icon: <CreditCardOutlined fontSize="large" />,
//           title: "دفعة أولى",
//           subtitle: "5%",
//         },
//         {
//           icon: <MonetizationOnOutlined fontSize="large" />,
//           title: "خطة الدفع",
//           subtitle: "أقساط حتى التسليم",
//         },
//         {
//           icon: <KeyOutlined fontSize="large" />,
//           title: "موعد التسليم",
//           subtitle: "تسليم في 2027",
//         },
//       ],
//     },
//   };

//   const { title, paragraph, items } = translations[language];

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     if (!sectionRef.current) return;

//     gsap.set(cardsRef.current, { opacity: 0, y: 30 });

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           gsap.to(cardsRef.current, {
//             opacity: 1,
//             y: 0,
//             duration: 1,
//             stagger: 0.2,
//             ease: "power3.out",
//           });
//         } else {
//           gsap.to(cardsRef.current, {
//             opacity: 0,
//             y: 30,
//             duration: 0.5,
//             ease: "power3.out",
//           });
//         }
//       },
//       { threshold: 0.3 }
//     );

//     observer.observe(sectionRef.current);

//     return () => {
//       observer.disconnect();
//     };
//   }, []);

//   return (
//     <div
//       ref={sectionRef}
//       className="position-relative py-5 px-3 text-center"
//       style={{ backgroundColor: "#f9f9f9" }}
//     >
//       <div
//         style={{
//           position: "absolute",
//           top: "-80px",
//           left: 0,
//           right: 0,
//           height: "80px",
//           background: "linear-gradient(to bottom, transparent, #f9f9f9)",
//           zIndex: 1,
//         }}
//         id="about"
//       />

//       <div className="container" style={{ position: "relative", zIndex: 2 }}>
//         <h2
//           style={{
//             fontFamily: "'Playfair Display', serif",
//             fontWeight: "700",
//             fontSize: "2.5rem",
//             color: "#1a1a1a",
//             marginBottom: "10px",
//           }}
//         >
//           {title}
//         </h2>
//         <p
//           style={{
//             maxWidth: "700px",
//             margin: "0 auto 40px",
//             fontSize: "1.05rem",
//             color: "#555",
//             fontFamily: "Inter, sans-serif",
//           }}
//         >
//           {paragraph}
//         </p>

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             flexWrap: isMobile ? "wrap" : "nowrap",
//             gap: "20px",
//             maxWidth: "1200px",
//             margin: "0 auto",
//           }}
//         >
//           {items.map((item, index) => (
//             <div
//               key={index}
//               ref={(el) => (cardsRef.current[index] = el)}
//               style={{
//                 flex: isMobile ? "1 1 100%" : "1 1 22%",
//                 borderRadius: "16px",
//                 border: "1px solid rgba(0,0,0,0.1)",
//                 background: "rgba(255,255,255,0.6)",
//                 backdropFilter: "blur(8px)",
//                 boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                 transition: "all 0.3s ease",
//                 padding: "20px",
//                 boxSizing: "border-box",
//                 textAlign: "center",
//                 opacity: 0,
//                 transform: "translateY(30px)",
//               }}
//             >
//               <div
//                 style={{
//                   color: "#005A78",
//                   marginBottom: "10px",
//                 }}
//               >
//                 {item.icon}
//               </div>
//               <h5
//                 style={{
//                   fontFamily: "Inter, sans-serif",
//                   fontWeight: "600",
//                   fontSize: "1.1rem",
//                   color: "#111",
//                 }}
//               >
//                 {item.title}
//               </h5>
//               <p
//                 style={{
//                   color: "#666",
//                   fontSize: "0.95rem",
//                   marginBottom: 0,
//                 }}
//               >
//                 {item.subtitle}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LuxuryInfoSection;





























import React, { useContext, useEffect, useRef } from "react";
import {
  BedOutlined,
  CreditCardOutlined,
  MonetizationOnOutlined,
  KeyOutlined,
} from "@mui/icons-material";
import gsap from "gsap";
import { LanguageContext } from "./LanguageContext";

const LuxuryInfoSection = () => {
  const { language } = useContext(LanguageContext);
  const isRTL = language === "ar";

  const sectionRef   = useRef(null);
  const eyebrowRef   = useRef(null);
  const titleRef     = useRef(null);
  const paraRef      = useRef(null);
  const cardsRef     = useRef([]);

  const translations = {
    en: {
      eyebrow:   "Sharjah's Premier Community",
      title:     "Welcome to Masar",
      paragraph:
        "Masar is Arada's flagship residential destination nestled in Sharjah's lush, wooded surroundings. From cozy townhouses to expansive luxury villas, Masar 1, 2 & 3 offer a seamless blend of nature, design, and modern living — crafted for families who seek the extraordinary.",
      items: [
        { icon: <BedOutlined sx={{ fontSize: "2rem" }} />,            title: "Unit Types",    subtitle: "2, 3, 4 & 5 Bedrooms" },
        { icon: <CreditCardOutlined sx={{ fontSize: "2rem" }} />,     title: "Down Payment",  subtitle: "Starting from 5%"      },
        { icon: <MonetizationOnOutlined sx={{ fontSize: "2rem" }} />, title: "Payment Plan",  subtitle: "Easy Installments"     },
        { icon: <KeyOutlined sx={{ fontSize: "2rem" }} />,            title: "Handover",      subtitle: "2026 – 2027"           },
      ],
    },
    ar: {
      eyebrow:   "أبرز مجتمعات الشارقة",
      title:     "مرحباً بك في مسار",
      paragraph:
        "مسار هو وجهة أرادَ السكنية الرائدة في قلب الشارقة الخضراء. من منازل التاون هاوس المريحة إلى الفلل الفاخرة الرحبة، تجمع مشاريع مسار 1 و2 و3 بين الطبيعة والتصميم الراقي وأسلوب الحياة العصري — لعائلات تستحق الاستثنائي.",
      items: [
        { icon: <BedOutlined sx={{ fontSize: "2rem" }} />,            title: "أنواع الوحدات", subtitle: "2 و3 و4 و5 غرف نوم" },
        { icon: <CreditCardOutlined sx={{ fontSize: "2rem" }} />,     title: "الدفعة الأولى", subtitle: "تبدأ من 5%"           },
        { icon: <MonetizationOnOutlined sx={{ fontSize: "2rem" }} />, title: "خطة الدفع",     subtitle: "أقساط ميسرة"          },
        { icon: <KeyOutlined sx={{ fontSize: "2rem" }} />,            title: "موعد التسليم",  subtitle: "2026 – 2027"           },
      ],
    },
  };

  const { eyebrow, title, paragraph, items } = translations[language];

  // ─── Animation ───────────────────────────────────────────────
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const resetAll = () => {
      gsap.set(eyebrowRef.current, { opacity: 0, y: 20 });
      gsap.set(titleRef.current,   { opacity: 0, y: 35 });
      gsap.set(paraRef.current,    { opacity: 0, y: 25 });
      gsap.set(cardsRef.current,   { opacity: 0, y: 50, scale: 0.94 });
    };

    const playAll = () => {
      resetAll();
      const tl = gsap.timeline();

      tl.to(eyebrowRef.current, { opacity: 1, y: 0, duration: 0.6, ease: "power3.out" })
        .to(titleRef.current,   { opacity: 1, y: 0, duration: 0.7, ease: "power3.out" }, "-=0.3")
        .to(paraRef.current,    { opacity: 1, y: 0, duration: 0.7, ease: "power3.out" }, "-=0.4")
        .to(cardsRef.current,   {
            opacity: 1, y: 0, scale: 1,
            stagger: 0.12,
            duration: 0.65,
            ease: "back.out(1.5)",
          }, "-=0.3");
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) playAll();
          else resetAll();
        });
      },
      { threshold: 0.12 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, [language]);

  // ─── Card hover ───────────────────────────────────────────────
  const onCardEnter = (el) => {
    gsap.to(el, { y: -7, boxShadow: "0 20px 45px rgba(74,124,63,0.2)", duration: 0.3, ease: "power2.out" });
  };
  const onCardLeave = (el) => {
    gsap.to(el, { y: 0,  boxShadow: "0 4px 24px rgba(0,0,0,0.07)",     duration: 0.3, ease: "power2.out" });
  };

  return (
    <section
      id="about"
      ref={sectionRef}
      dir={isRTL ? "rtl" : "ltr"}
      style={{
        position:   "relative",
        padding:    "90px 0 80px",
        background: "linear-gradient(170deg, #f4f8f4 0%, #ffffff 50%, #f0f7f0 100%)",
        fontFamily: "'Cairo', sans-serif",
        overflow:   "hidden",
      }}
    >
      {/* Wavy top edge */}
      <div style={{ position: "absolute", top: "-60px", left: 0, right: 0,
        height: "80px", overflow: "hidden", zIndex: 1, pointerEvents: "none" }}>
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none"
          style={{ width: "100%", height: "100%", display: "block" }}>
          <path
            d="M0,0 L1440,0 L1440,20 Q1300,75 1100,45 Q900,15 720,55
               Q540,90 360,45 Q180,5 0,55 Z"
            fill="#ffffff"
          />
        </svg>
      </div>

      {/* Blobs */}
      <div style={{
        position: "absolute", top: "-80px",
        [isRTL ? "left" : "right"]: "-80px",
        width: "340px", height: "340px", borderRadius: "50%",
        background: "radial-gradient(circle, rgba(74,124,63,0.08) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", bottom: "-60px",
        [isRTL ? "right" : "left"]: "-60px",
        width: "260px", height: "260px", borderRadius: "50%",
        background: "radial-gradient(circle, rgba(106,173,85,0.07) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />

      <div className="container" style={{ position: "relative", zIndex: 2 }}>

        {/* ── Header ── */}
        <div style={{ textAlign: "center", marginBottom: "48px" }}>

          {/* Eyebrow */}
          <div
            ref={eyebrowRef}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              gap: "10px", marginBottom: "14px", opacity: 0,
            }}
          >
            <span style={{
              display: "inline-block", width: "36px", height: "2px",
              background: "linear-gradient(to right, transparent, #4a7c3f)",
            }} />
            <span style={{
              fontFamily: "'Cairo', sans-serif", fontSize: "0.78rem",
              fontWeight: 700, letterSpacing: "0.18em",
              textTransform: "uppercase", color: "#4a7c3f",
            }}>
              🌿 {eyebrow}
            </span>
            <span style={{
              display: "inline-block", width: "36px", height: "2px",
              background: "linear-gradient(to left, transparent, #4a7c3f)", opacity: 0.6,
            }} />
          </div>

          {/* Title */}
          <h2
            ref={titleRef}
            style={{
              fontFamily: "'Cairo', sans-serif", fontWeight: 900,
              fontSize: "clamp(1.9rem, 4.5vw, 3rem)", color: "#0f1f0f",
              lineHeight: 1.2, marginBottom: "14px", opacity: 0,
            }}
          >
            {title}
          </h2>

          {/* Paragraph */}
          <p
            ref={paraRef}
            style={{
              maxWidth: "660px", margin: "0 auto",
              fontSize: "clamp(0.95rem, 2vw, 1.05rem)",
              color: "#4a5a4a", lineHeight: 1.85,
              fontFamily: "'Cairo', sans-serif", opacity: 0,
            }}
          >
            {paragraph}
          </p>
        </div>

        {/* ── Cards ── */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
          gap: "20px", maxWidth: "1100px", margin: "0 auto",
        }}>
          {items.map((item, i) => (
            <div
              key={i}
              ref={(el) => (cardsRef.current[i] = el)}
              onMouseEnter={(e) => onCardEnter(e.currentTarget)}
              onMouseLeave={(e) => onCardLeave(e.currentTarget)}
              style={{
                borderRadius:   "18px",
                border:         "1px solid rgba(74,124,63,0.15)",
                background:     "rgba(255,255,255,0.85)",
                backdropFilter: "blur(10px)",
                boxShadow:      "0 4px 24px rgba(0,0,0,0.07)",
                padding:        "32px 24px",
                textAlign:      "center",
                cursor:         "default",
                opacity:        0,
              }}
            >
              {/* Icon circle */}
              <div style={{
                width: "60px", height: "60px", borderRadius: "50%",
                background: "linear-gradient(135deg, rgba(74,124,63,0.12) 0%, rgba(106,173,85,0.18) 100%)",
                border: "1px solid rgba(74,124,63,0.2)",
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto 16px", color: "#4a7c3f",
              }}>
                {item.icon}
              </div>

              {/* Number badge */}
              <div style={{
                fontFamily: "'Cairo', sans-serif", fontSize: "0.65rem",
                fontWeight: 700, letterSpacing: "0.12em",
                color: "#6aad55", marginBottom: "6px", textTransform: "uppercase",
              }}>
                0{i + 1}
              </div>

              <h5 style={{
                fontFamily: "'Cairo', sans-serif", fontWeight: 700,
                fontSize: "clamp(0.95rem, 2vw, 1.05rem)",
                color: "#0f1f0f", marginBottom: "8px",
              }}>
                {item.title}
              </h5>

              <p style={{
                fontFamily: "'Cairo', sans-serif",
                fontSize: "clamp(0.88rem, 1.8vw, 0.98rem)",
                color: "#4a7c3f", fontWeight: 600, marginBottom: 0,
              }}>
                {item.subtitle}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LuxuryInfoSection;